// @ts-nocheck
import * as React from 'react';
import { getParameterByName } from 'Jsx/Utils/formatters';
import styled from 'styled-components';

type VideoSectionProps = {
  videoUrl: string;
  category?: string;
};

const ScVideoContainer = styled.div<{ youtube: boolean }>`
  background: #c7c7c7;
  width: 100% !important;
  .fb_iframe_widget_fluid_desktop,
  .fb_iframe_widget_fluid_desktop span,
  .fb_iframe_widget_fluid_desktop iframe {
    width: 100% !important;
    background: #fff;
  }
  min-height: 160px;
  margin-bottom: 15px;
  .youtubeWrapper {
    position: relative;
    padding-bottom: 49.25%;
    padding-top: 25px;
    height: 0;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  @media (min-width: 768px) {
    min-height: ${({ youtube }) => (youtube ? '293px' : '335px')};
    margin-bottom: 40px;
    .youtubeWrapper {
      padding-bottom: 53.25%;
    }
  }

  @media (min-width: 1366px) {
    min-height: 380px;
  }
`;

const VideoSecction = ({ videoUrl }: VideoSectionProps) => {
  const changeYoutubeUrl = (url: string) => {
    const urlArray = url.split('/');
    const embed = urlArray.filter(t => t === 'embed')[0];
    const videoID = getParameterByName('v', url);
    const newUrl = embed ? url : `https://www.youtube.com/embed/${videoID}`;

    return newUrl;
  };

  const youtube = videoUrl.includes('youtube');

  return (
    <ScVideoContainer youtube={youtube}>
      {youtube ? (
        <div className="youtubeWrapper">
          <iframe
            src={changeYoutubeUrl(videoUrl)}
            title={changeYoutubeUrl(videoUrl)}
          />
        </div>
      ) : (
        <div
          className="fb-video"
          data-href={videoUrl}
          data-width="500"
          data-allowfullscreen="false"
          data-autoplay="true"
          data-show-captions="true"
        />
      )}
    </ScVideoContainer>
  );
};

export default VideoSecction;
